import { Modal } from '@toggle/design-system';
import React, { useEffect } from 'react';
import { useMatch, useNavigate, useSearchParams } from 'react-router';

import { appPaths } from '~/routes/app-paths';
import { queryKeys } from '~/routes/query-params';
import { useWatchlistManagerWidget } from '~/stores/use-watchlist-manager-widget/useWatchlistManagerWidget';
import { useOnboardingStore } from '~/views/onboarding/hooks/useOnboardingStore';
import { WatchlistManagerWidget } from '~/widgets/watchlist-manager-widget/WatchlistManagerWidget';

import styles from './WatchlistManagerModal.module.scss';

export const WatchlistManagerModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const isOnWatchlistRoute = useMatch(`${appPaths.watchlist}/*`);

  const clearStore = useOnboardingStore(state => state.clearStore);
  const { setIsAddMode, setOnConfirmCallback, setShouldResetList } =
    useWatchlistManagerWidget(state => ({
      setIsAddMode: state.setIsAddMode,
      setOnConfirmCallback: state.setOnConfirmCallback,
      setShouldResetList: state.setShouldResetList,
    }));

  const onClose = () => {
    searchParams.delete(queryKeys.widget);
    setSearchParams(searchParams);
  };

  const onListCreated = (id: string) => {
    if (isOnWatchlistRoute) {
      navigate(`${appPaths.watchlist}/${id}`);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    return () => {
      setIsAddMode();
      setOnConfirmCallback();
      setShouldResetList();
      clearStore();
    };
  }, []);

  return (
    <Modal
      className={styles.styledModal}
      data-testid="watchlist-manager-modal"
      isOpen
      onClose={onClose}
    >
      <WatchlistManagerWidget
        onListCreated={onListCreated}
        onCancel={onClose}
      />
    </Modal>
  );
};
